// ===========================================
// APP PROVIDERS
// ===========================================
import { type ReactNode, Suspense } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from '@/store';
import '@/i18n';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Loading fallback component
 */
function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
    </div>
  );
}

/**
 * App Providers wrapper
 * Wraps the app with all necessary providers
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ReduxProvider store={store}>
      <Suspense fallback={<LoadingFallback />}>
        {children}
      </Suspense>
    </ReduxProvider>
  );
}

export default AppProviders;
